export default __webpack_public_path__ + "static/media/Maithili_dm_2.9ef0059c.mp3";